'use strict'
import { codeData } from '@/utils/codeData';

const bulkPay = {
    path: 'pay-statistics',
    name: 'pay-statistics',
    meta: {
        title: '秀川结算中心-综合服务平台',
        name: '结算管理',
        code: ''
    },
    // component: () => import('@/pages/bulkPay/BulkDetails'),
    component: () => import('@/components/RouterViewTab'),
    children: [
		{
            path: 'add-pay-statistics',
            name: 'add-pay-statistics',
            meta: {
                title: '打款统计-结算管理-秀川结算中心-综合服务平台',
                name: '打款统计',
                tagsTitle: '打款统计',
                code: ''
            },
            component: () => import('@/pages/bulkPay/AddBulkDetails'),
        },
        {
            path: 'pay-statistics',
            name: 'pay-statistics',
            meta: {
                title: '打款明细-结算管理-秀川结算中心-综合服务平台',
                name: '打款明细',
                tagsTitle: '打款明细',
                code: ''
            },
            component: () => import('@/pages/bulkPay/BulkDetails'),
        }
    ]
};




export default bulkPay;